import { renderElement } from "../../utils/use-render.js";
import { useStatusIndicatorContext } from "./context.js";
import { getStatusIndicatorDisplayValue } from "@videojs/core";
import { forwardRef } from "react";
//#region src/ui/status-indicator/value.tsx
const StatusIndicatorValue = forwardRef(function StatusIndicatorValue(componentProps, forwardedRef) {
	const { render, className, style, ...elementProps } = componentProps;
	const { state } = useStatusIndicatorContext();
	return renderElement("span", {
		render,
		className,
		style
	}, {
		state,
		ref: forwardedRef,
		props: [{ children: getStatusIndicatorDisplayValue(state) }, elementProps]
	});
});
//#endregion
export { StatusIndicatorValue };

//# sourceMappingURL=value.js.map